<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="d-flex flex-grow-1 flex-md-grow-0">
            <h1 class="m-subheader__title m-subheader__title--separator m--margin-top-15-mobile" v-encode="pageTitle">
            </h1>
            <div class="m-nav m-nav--inline mt-3 mt-md-2 ml-auto">
              <div class="d-flex">
                <div v-click-outside="closeStatusDropdown" class="m-dropdown m-dropdown--inline m-dropdown--align-right"
                     :class="{'m-dropdown--open': statusDropdownOpen}" aria-expanded="true">
                  <a href="#" class="m-dropdown__toggle btn-secondary btn dropdown-toggle"
                     @click="toggleStatusDropdown">
                    {{ statusName }}
                  </a>
                  <div class="m-dropdown__wrapper" :class="[type !== 2 && 'width-125', type === 2 && 'width-215']" style="z-index: 2;">
                    <span class="m-dropdown__arrow m-dropdown__arrow--right"></span>
                    <div class="m-dropdown__inner">
                      <div class="m-dropdown__body">
                        <div class="m-dropdown__content">
                          <ul class="m-nav">
                            <li v-for="(status, i) in statuses" :key="i" class="m-nav__item m-nav__item-ls">
                              <a href="#" class="m-nav__link" @click="setStatus(i)">
                                <span class="m-nav__link-text">{{ status }}</span>
                              </a>
                            </li>

                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row m--visible-mobile">
          <div class="col">
          </div>
        </div>
      </div>

      <div v-if="itemsFiltered.length" class="m-content">
        <div class="row">
          <quiz v-for="item in itemsFiltered.slice(0, showOnPage)" :quiz="item" :key="item.id"
                :extended-button="extendedButtons"
                :return-page="returnPage"
                :return-status="status"
                :return-show-on-page="showOnPage"
                @refresh="refresh"></quiz>
        </div>
        <div v-if="isThereMore" class="row">
          <div class="col m--align-center">
            <button type="button" class="btn btn-sm m-btn--custom m-btn--pill btn-ls"
                    @click="showMore">{{$t('Load more')}}
            </button>
          </div>
        </div>
      </div>
      <div v-else-if="isLoading" class="m-content text-center">
        <spinner v-if="isLoading"></spinner>
      </div>
      <div v-else class="m-content text-left" >
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                {{ emptyText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import Quiz from "@/components/quiz/Quiz";
import Spinner from "@/components/spinner/Spinner";
import Page from "@/components/pages/Page";
import ClickOutside from "vue-click-outside";
import Encode from "@/directives/encode";


const STATUS_ACTIVE = 0;
const STATUS_ALL = 2;

const TYPE_QUIZZES = 0;
const TYPE_POLLS = 1;
const TYPE_SURVEYS = 2;

export default {
  name: "SurveysGrid",
  props: {
    items: Array,
    pageTitle: String,
    emptyText: String,
    extendedButtons: Boolean,
    type: {
      type: Number,
      default: 0
    },
    returnPage: String
  },
  components: {Quiz, Spinner, Page},
  directives: {
    ClickOutside,
    Encode
  },
  data() {
    return {
      TYPE_QUIZZES: TYPE_QUIZZES,
      TYPE_POLLS: TYPE_POLLS,
      TYPE_SURVEYS: TYPE_SURVEYS,
      isLoading: false,
      statusDropdownOpen: false,
      status: parseInt(this.$route.query.status || '0'),
      showOnPage: parseInt(this.$route.query.showOnPage || '6'),
    }
  },
  methods: {
    showMore() {
      this.showOnPage += 6;
    },
    refresh() {
      this.$emit('refresh');
    },
    closeStatusDropdown() {
      this.statusDropdownOpen = false;
    },
    toggleStatusDropdown() {
      this.statusDropdownOpen = !this.statusDropdownOpen;
    },
    setStatus(status) {
      this.status = status;
      this.statusDropdownOpen = false;
    },
  },
  computed: {
    isThereMore() {
      return this.itemsFiltered.length > this.showOnPage;
    },
    statusName() {
      return this.statuses[this.status];
    },
    itemsFiltered() {
      if (this.status === STATUS_ALL) {
        return this.items;
      }

      return this.items.filter(q => {
        return this.status === STATUS_ACTIVE
            ? !q.result // without result
            : !!q.result; // with result
      })
    },
    statuses() {
      let solved = this.$t('Solved');

      if (this.type === TYPE_POLLS) {
        solved = this.$t('Filled')
      }

      if (this.type === TYPE_SURVEYS) {
        solved = this.$t('Solved / Filled')
      }

      return [
        this.$t('Active'),
        solved,
        this.$t('All'),
      ]
    }
  }
}
</script>

<style scoped>
.m-nav .m-nav__item-ls:hover:not(.m-nav__item--disabled) > .m-nav__link .m-nav__link-text {
  color: var(--accent-color) !important;
}

.width-125 {
  width: 125px !important;
}

.width-215 {
  width: 215px !important;
}


</style>
